import auth from '@/router/middlewares/auth.js';
import SettingsView from '@/pages/settings/index.vue';
import profile from '@/pages/settings/profile.vue';
import ChannelsView from '@/pages/settings/channels.vue';
import PasswordSecurityView from '@/pages/settings/passwordSecurity.vue';
import HelpView from '@/pages/settings/help.vue';
import ContactView from '@/pages/settings/contact.vue';
import accountDetails from '@/pages/settings/account/accountDetails.vue';
import AccountNotificationsView from '@/pages/settings/account/notifications.vue';
import AccountTeamView from '@/pages/settings/account/teamMembers.vue';
import WorkspaceDetailsView from '@/pages/settings/workspace/workspaceDetails.vue';
import WorkspaceNotifications from '@/pages/settings/workspace/workspaceNotifications.vue';

export default [
  {
    path: '/settings',
    redirect: '/settings/profile',
    name: 'Settings',
    component: SettingsView,
    meta: {
      layout: 'AuthenticatedLayout',
      middleware: [auth]
    },
    children: [
      {
        path: '/settings/profile',
        name: 'Profile',
        component: profile
      },
      {
        path: '/settings/channels',
        name: 'Channels',
        component: ChannelsView
      },
      {
        path: '/settings/password',
        name: 'PasswordSecurity',
        component: PasswordSecurityView
      },
      {
        path: '/settings/help',
        name: 'Help',
        component: HelpView
      },
      {
        path: '/settings/contact-us',
        name: 'Contact',
        component: ContactView
      },
      {
        path: '/settings/account-details',
        name: 'Details',
        component: accountDetails
      },
      {
        path: '/settings/account-notifications',
        name: 'Notifications',
        component: AccountNotificationsView
      },
      {
        path: '/settings/account-team',
        name: 'Team Members',
        component: AccountTeamView
      },

      {
        path: '/settings/workspace-details',
        name: 'Workspace Details',
        component: WorkspaceDetailsView
      },
      {
        path: '/settings/workspace-notifications',
        name: 'Workspace Notifications',
        component: WorkspaceNotifications
      }
    ]
  }
];
